const fixture = {
    totalPages: 20,
    navigationSize: 5,
    onPageSelected: (value: number) => alert(`Selected page = ${value}`)
};

export default fixture;